module.exports = __webpack_public_path__ + "static/fonts/notokr-light.2ea9b0e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/waste-glass-bottle2/font/notokr-light.woff
// module id = RfgD
// module chunks = 0